import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"outlined":"","items":_vm.items,"label":_vm.$t('Rate type'),"hide-details":"auto"},model:{value:(_vm.rate_type),callback:function ($$v) {_vm.rate_type=$$v},expression:"rate_type"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }